'use client';

import {preconnect, prefetchDNS} from 'react-dom';

export default function PreloadMeta() {
  const url = `${process.env.NEXT_PUBLIC_PROTOCOL}://${process.env.NEXT_PUBLIC_API_DOMAIN}`;
  preconnect(url);
  prefetchDNS(url);

  return null;
}
